import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { ButtonComponent } from '../../../../../components/button/button.component';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { Location } from '@angular/common';

@Component({
    selector: 'cms-partial-category-top-component-facets',
    templateUrl: './facets.component.html',
    styleUrls: ['./facets.component.scss'],
    standalone: true,
    imports: [CommonModule, ButtonComponent],
})
export class FacetsComponent extends CmsPartialComponentClass {
    @Input() facetRowSet: any;
    @Input() grayBackgroundRows: any = [];
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        @Inject(PLATFORM_ID) platformId: Object,
        breakpointObserver: BreakpointObserver,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                platformId,
                breakpointObserver,
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }

    /**
     * Browsers only scroll a focused element into view when it's fully hidden, so a facet half
     * off the edge of its scroller stays half hidden (and its ring clipped). Scroll the whole
     * ringed circle into view instead.
     */
    revealFocusedFacet(event: FocusEvent): void {
        const target = event.target as HTMLElement;
        // Keyboard focus only: a mouse click shouldn't move the row under the pointer
        if (!target.matches?.(':focus-visible')) return;
        const scroller = event.currentTarget as HTMLElement;
        const circle = (target.closest('.type-icon-facet, .type-icon-facet-background') ?? target).getBoundingClientRect();
        const view = scroller.getBoundingClientRect();
        const ringRoom = 8; // 4px offset + 2px ring, plus a little space
        if (circle.right + ringRoom > view.right) {
            scroller.scrollLeft += circle.right + ringRoom - view.right;
        } else if (circle.left - ringRoom < view.left) {
            scroller.scrollLeft -= view.left - (circle.left - ringRoom);
        }
    }
}
